// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"ArrowLink__pc_only___2wCY-","sp_only":"ArrowLink__sp_only___LZJ2F","arrow_link":"ArrowLink__arrow_link___23pkI"};